// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JJUJ","comment":"styles_comment__35crw"};